<template>
  <div class="success-payment">
    <div v-if="this.$route.query.STATUS==='SUCCESS'" class="head-panel">
      <div class="head">
        <div class="icon-circle">
          <img src="../assets/images/success.svg" />
        </div>
        <h2>{{$t('successfulpayment')}}</h2>
        <div class="rupees">₹{{this.$route.query.TXN_AMOUNT}} <b>{{this.$route.query.GOLD_AMOUNT}}g</b></div>
        
        <div class="date">{{getLongFormattedDate(new Date().toISOString(), "en-IN")}}</div>
        
      </div>
    </div>
    <div v-else class="head-panel headpanel">
      <div class="head">
        <div class="icon-circle">
          <img src="../assets/images/warning.svg" />
        </div>
        <h2>{{$t('unsuccessfulpayment')}}</h2>
         
      </div>
    </div>
    <div class="seller-agent">
      <h4 class="seller-text">{{$t('selleragent')}}</h4>
      <div class="seller-details">
        <div class="image">
          <img src="../assets/images/gold-text.png" />
          <div class="safegold-text">SAFEGOLD</div>
        </div>
        <div class="gold-purity">
          <span class="goldpurity-text">
            (24k 99.95) {{$t('purity')}}
            <!-- <span
              class="goldbased-price"
            >{{$t('basedongoldprise')}} Rs.{{gold.current_price}}/g</span>-->
          </span>
        </div>
      </div>
      <span v-if="this.$route.query.TXN_ID" class="order">Order Id: {{ this.$route.query.TXN_ID }}</span>
    </div>
    <div class="save-lock">
      <router-link to="/">
        {{$t('seelocker')}}
        <i class="fa fa-angle-right"><img src="../assets/images/ic_right.svg" /></i>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getLongFormattedDate } from "../utils/helper";
export default {
  computed: {
    ...mapGetters(["gold"])
  },

  methods: {
    getLongFormattedDate
  }
};
</script>